import * as url from "../url.helper";

import { get, post } from "../api.helper";

export const addEntity = data => post(url.ADD_ENTITY, data);

export const getEntity = data => post(url.GET_ENTITY, data);

export const getAllEntity = data => post(url.ALL_ENTITY, data);

export const getDeleteEntity=data=>post(url.DELETE_ENTITY,data);

export const getAllEntityAnchor = data => post(url.ANCHOR_ENTITY, data);

export const getEntityAnchorDeal = data => post(url.GET_ENTITY_ANCHOR_DEAL, data)

export const getOneEntity = data => post(url.GET_ONE_ENTITY, data);

export const getEntityInformation = data => post(url.GET_ENTITY_INFORMATION, data);

export const editEntity = data => post(url.EDIT_ENTITY, data);

export const pushToTradeasyPayearly = data => post(url.PUSH_TO_TRADEASY_PAYEARLY, data)

export const pushToTradeasy = data => post(url.PUSH_TO_TRADEASY, data)

export const pushToPayearly = data => post(url.PUSH_TO_PAYEARLY, data)

export const getCpAnchor = data => post(url.GET_CP_ANCHOR,data)

export const addAddress = data => post(url.ADD_ADDRESS, data);

export const getAddress = data => post(url.GET_ADDRESS, data);

export const getPersonAddress = data => post(url.GET_ADDRESS_BY_PERSONID, data);

export const editAddress = data => post(url.EDIT_ADDRESS, data);

export const deleteAddress = data => post(url.DELETE_ADDRESS, data);

export const addBorrowing= data =>  post(url.ADD_BORROWING, data);

export const getBorrowingList= data =>  post(url.GET_BORROWING, data);

export const editBorrowing= data =>  post(url.EDIT_BORROWING, data);

export const addAuthorisedPerson= data =>  post(url.ADD_AUTHORISEDPERSON, data);

export const addProprietor= data =>  post(url.ADD_PROPRIETOR, data);

export const getAuthorisedPersonList= data =>  post(url.GET_AUTHORISEDPERSON, data);

export const deleteAuthorisedPersonList= data =>  post(url.DELETE_AUTHORISEDPERSON, data);

export const editAuthorisedPerson= data =>  post(url.EDIT_AUTHORISEDPERSON, data);

export const editAuthorisedPersonStatus= data =>  post(url.EDIT_AUTHORISEDPERSON_STATUS, data);

export const addShareholding= data =>  post(url.ADD_SHAREHOLDING, data);

export const getShareholdingList= data =>  post(url.GET_SHAREHOLDING, data);

export const editShareholding= data =>  post(url.EDIT_SHAREHOLDING, data);

export const callGetState= data =>  get(url.GET_STATE, data);

export const callGetCity= data => post(url.GET_CITY,data)

export const getAuthorisedPersonEntityList = data => post(url.GET_AUTHORIZED_PERSON_ENTITY_LIST, data);

export const getCommercialsList = data => post(url.GET_COMMERCIALS,data);

export const getOneCommercial = data => post(url.GET_ONE_COMMERCIAL, data);

export const addCommercial = data => post(url.ADD_COMMERCIAL, data);

export const updateCommercial = data => post(url.UPDATE_COMMERCIAL, data);

export const getEntityDetails = data => post(url.GET_ENTITY_DETAIL, data)
export const downloadEntityInfo = data => post(url.EXPORT_ENITTY_INFORMATION, data)
export const getEntityScoreMeResponse = data => post(url.GET_ENTITY_SCOREME_RESPONSE, data)
export const addDash = data => post('/entity/add-dash', data);
export const  getOneDash = data => post('/entity/get-dash', data);
export const  getCrifReport = data => post(url.GET_CRIF, data);
export const  getCrifReportCommercial = data => post(url.GET_CRIF_COMMERCIAL, data);
export const  addCrifReport = data => post(url.ADD_CRIF_REPORT, data);
export const  getCrifReportList = data => post(url.GET_CRIF_REPORT, data);
export const  deleteCrifReportList = data => post(url.DELETE_CRIF_REPORT, data);

export const getOwnerID = data => post(url.GET_OWNER_ID, data);
export const getCIUser = data => post(url.GET_CI_USERS, data);
export const getCIUserRolewise = data => post(url.GET_CI_USERS_ROLEWISE, data);

export const addPartner = data => post(url.ADD_PARTNER, data);
export const editPartner = data => post(url.EDIT_PARTNER, data);
export const stage2Question = data => post(url.STAGE_QUESTION_PHASE, data);

export const reqConsent = data => post(url.REQ_CONSENT, data);
// Add Task Against Entity
export const addTask = data => post(url.ADD_TASK, data);
export const getTask = data => post(url.GET_TASK, data);
export const getTaskById = data => post(url.GET_TASK_BY_ID, data);
export const getTaskByDealAndStatus = data => post(url.GET_TASK_BY_DEAL_AND_STATUS, data);
export const updateTask = data => post(url.UPDATE_TASK, data);
export const updateTaskStatus = data => post(url.UPDATE_TASK_STATUS, data);
export const sendReminder = data => post(url.SEND_REMINDER, data);
export const getTaskByEntity = data => post(url.GET_TASK_BY_ENTITY, data);

// Meeting
export const updateMeeting = data => post(url.UPDATE_MEETINGS, data);
export const updateMeetingStatus = data => post(url.UPDATE_MEETINGS_STATUS, data);
export const scheduleMeeting = data => post(url.SCHEDULE_MEETING, data);
export const getAllMeeting = data => post(url.GET_ALL_MEETINGS, data);
export const getMeetingByEntity = data => post(url.GET_MEETINGS_BY_ENTITY, data);
export const getMeetingByDealAndStatus = data => post(url.GET_MEETINGS_BY_DEAL_AND_STATUS, data);
export const getMeetingByID = data => post(url.GET_MEETINGS_BY_ID, data);
export const addEvent = data => post(url.ADD_EVENT, data);


// ENTITY-DEAL NOTES
export const getNotes = data => post(url.GET_NOTES, data);
export const getNoteById = data => post(url.GET_NOTE_BY_ID, data);
export const addNotes = data => post(url.ADD_NOTES, data);
export const updateNotes = data => post(url.UPDATE_NOTES, data);
export const deleteNotes = data => post(url.DELETE_NOTES, data);
export const getNotesTableData = data => post(url.GET_NOTES_TABLE_DATA, data);

// Extract all anchors from entity table
export const callAnchorList = data => post(url.ANCHOR_LIST, data)
export const changeUserStatus = data => post(url.CHANGE_USER_STATUS, data);
export const checkEntityDetails = data => post(url.CHECK_ENTITY_DETAILS, data);
export const getUserConsent = data => post(url.GET_USER_CONSENT, data);
export const updateEntityStatus = data => post(url.UPDATE_ENTITY_STATUS, data);
export const callUplodBulkOrder = data => post(url.UPLOAD_BULK_ENTITY, data);
export const callgetFileByBatch = data => post(url.GET_FILE_BY_BATCH, data);
export const callGetAllFileDataCount = data => post(url.GET_FILE_COUNT, data)

export const callgetFileByFileId = data => post(url.GET_FILE_BY_FILEID, data);
export const callGetAllFileData = data => post(url.GET_ALL_FILE_DATA, data)
export const callgetFileById = data => post(url.GET_FILE_BY_ID, data);
export const createBulkEntity = data => post(url.CREATE_BULK_ENTITY, data);

export const checkEntityExistOrNot = data => post(url.CHECK_ENTITY_EXIST, data);
